import { handleActions } from 'redux-actions'
import { set } from 'lodash/fp'
import { IUser } from '../types/user'
import { IPaginationState } from '../types/common'
import {
  SET_USERS,
  SET_USERS_PAGINATION_STATE,
  SET_USERS_TOTAL,
} from './usersActions'

const DEFAULT_STATE = {
  users: [] as IUser[],
  paginationState: {} as IPaginationState,
  total: 0 as number,
}

export default handleActions<typeof DEFAULT_STATE, any>(
  {
    [SET_USERS]: (state, { payload }: SET_USERS) =>
      set('users', payload, state),
    [SET_USERS_PAGINATION_STATE]: (
      state,
      { payload }: SET_USERS_PAGINATION_STATE,
    ) => set('paginationState', payload, state),
    [SET_USERS_TOTAL]: (state, { payload }: SET_USERS_TOTAL) =>
      set('total', payload, state),
  },
  DEFAULT_STATE,
)
